/*
* Requires:
*
* debounce
* jquery
* bootstrap
* moment.js
* bootstrap datetime picker
*
* */

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});
var allDataGrids = [];

var DataGrid = function($dataGridElem) {
  dataGridHelper.checkDataGrids();
  var dataGrid = this;

  this.$selectedRow               = null;
  this.rowOpen                    = false;
  this.additionalBindingFunctions = [];
  this.onDraw                     = function(callable) {
    if (typeof callable !== "function") {
      throw new Error("Must pass a function to the onDraw() method.");
      return false;
    }
    this.onDrawFunctions.push(callable);
  };
  this.onDrawFunctions            = [];
  this.onOpen                     = function(callable) {
    if (typeof callable !== "function") {
      throw new Error("Must pass a function to the onOpen() method.");
      return false;
    }
    this.onOpenFunctions.push(callable);
  };
  this.onOpenFunctions            = [];
  this.onClose                    = function(callable) {
    if (typeof callable !== "function") {
      throw new Error("Must pass a function to the onClose() method.");
      return false;
    }
    this.onCloseFunctions.push(callable);
  };
  this.onCloseFunctions           = [];
  this.beforeSearch               = function() {
    // if you return "false", the search is stopped
    return true;
  };
  this.afterSearch                = function() {
    // if you return "false", the table is not updated
    return true;
  };
  this.afterDraw                  = function() {

    this.wrapper.find(".data-grid-checkbox-row:first").change();
    if (typeof getStickyHeader === 'function') {
      var stickyHeader = getStickyHeader(this.wrapper);
      stickyHeader.scroll();
    }
    var $advancedSearchesCount = $(".data-grid-advanced-number-search[data-grid-session-id='" + this.id + "']");
    if ($advancedSearchesCount.length) {
      if ($advancedSearchesCount.attr("data-grid-parenthesis") === "yes") {
        $advancedSearchesCount.html("(" + this.advanacedSearchCount + ")");
      }
      else {
        $advancedSearchesCount.html(this.advanacedSearchCount);
      }
      if ($advancedSearchesCount.attr("data-grid-hide-on-zero") === "yes") {
        if (this.advanacedSearchCount === 0 || this.advanacedSearchCount === "0") {
          $advancedSearchesCount.hide();
        }
        else {
          $advancedSearchesCount.show();
        }
      }
    }


    this.onDrawFunctions.forEach(function(callable) {
      callable(this);
    });
    return true;
  };

  this.initVars           = function($dataGridElem) {
    this.id                     = $dataGridElem.attr("data-grid-session-id");
    this.name                   = $dataGridElem.attr("data-grid-name");
    this.currentPage            = $dataGridElem.attr("data-grid-current-page");
    this.totalPages             = $dataGridElem.attr("data-grid-total-pages");
    this.advanacedSearchCount   = $dataGridElem.attr("data-grid-advanced-search-count");
    this.pageName               = $dataGridElem.attr("data-grid-page-name") || "page";
    this.pageSizeName           = $dataGridElem.attr("data-grid-page-size-name") || "page_size";
    this.sessionIdVarName       = $dataGridElem.attr("data-grid-session-id-var-name") || "page";
    this.hiddenVarsName         = $dataGridElem.attr("data-grid-hidden-vars-name");
    this.scrollAboveGrid        = $dataGridElem.attr("data-grid-scroll-above-grid") === "yes";
    this.scrollAboveGridAtStart = $dataGridElem.attr("data-grid-scroll-above-grid-at-start") === "yes";
    this.scrollAboveGridAnimate = $dataGridElem.attr("data-grid-scroll-above-grid-animate") === "yes";
    this.scrollAboveGridPixels  = $dataGridElem.attr("data-grid-scroll-above-grid-pixels");
    this.stickyHeader           = $dataGridElem.attr("data-grid-sticky-table-header") === "yes";
    this.scrollParentSelector   = $dataGridElem.attr("data-grid-scroll-parent-selector");
    this.stickyHeaderZIndex     = $dataGridElem.attr("data-grid-sticky-header-z-index");
    this.openOnClick            = $dataGridElem.attr("data-grid-open-on-click") === "yes";
    this.openDelay              = $dataGridElem.attr("data-grid-open-delay") === "yes";
    this.openFirstRow           = $dataGridElem.attr("data-grid-open-first-row") === "yes";
    this.openHide               = $dataGridElem.attr("data-grid-open-hide");
    this.moveSettingsDialogTo   = $dataGridElem.attr("data-grid-move-settings-dialog-to");
    this.rememberScroll         = 0;
    this.$rememberScrollDiv     = null;
    this.defaultFontSize        = $dataGridElem.attr("data-grid-default-font-size");
    this.defaultSpacing         = $dataGridElem.attr("data-grid-default-spacing");


    this.ajaxUrl           = $dataGridElem.attr("data-ajax-url");
    this.ajaxInputUrl      = $dataGridElem.attr("data-ajax-input-url");
    this.csvUrl            = $dataGridElem.attr("data-csv-url");
    this.ajaxOpenUrl       = $dataGridElem.attr("data-ajax-open-url");
    this.wrapper           = $dataGridElem;
    this.$open             = $(".data-grid-open[data-grid-session-id='" + dataGrid.id + "']");
    this.settingsModal     = $dataGridElem.find(".data-grid-settings-modal");
    this.updateUrlEnabled  = $dataGridElem.attr("data-grid-update-url") === "yes";
    this.defaultToLastPage = $dataGridElem.attr("data-grid-default-to-last-page") === "yes";
    if (typeof this.searchAjaxRequests === "undefined") {
      this.searchAjaxRequests = [];
    }
    if (typeof this.openAjaxRequests === "undefined") {
      this.openAjaxRequests = [];
    }
    if (this.moveSettingsDialogTo.length > 0) {
      var $newLoc        = $(this.moveSettingsDialogTo);
      var $alreadyExists = $newLoc.find(".data-grid-settings-modal");
      if ($alreadyExists.length) {
        this.settingsModal.remove();
        this.settingsModal = $alreadyExists;
      }
      else {
        $(this.moveSettingsDialogTo).append(this.settingsModal.detach());
      }

    }
  };
  this.closeSettingsModal = function() {
    this.settingsModal.modal("hide");
  };
  this.openSettingsModal  = function() {
    this.settingsModal.modal("show");
  };

  this.addSearch = function($target, field, operation) {

    operation                   = operation || "=";
    var data                    = {field: field, operation: operation};
    data[this.sessionIdVarName] = this.id;
    if (this.ajaxInputUrl.length < 1) {
      return false;
    }
    $.ajax({
      url     : this.ajaxInputUrl,
      type    : "POST",
      data    : data,
      success : function(response) {
        var $html          = $(response + "<br>");
        var $searchInput   = $html.filter(".data-grid-search");
        var $alreadyExists = $("[data-grid-session-id='" + dataGrid.id + "'][name='" + $searchInput.attr("name") + "']");

        if ($alreadyExists.length) {
          $alreadyExists.focus();
          return true;
        }

        $target.append($html);
        if ($searchInput.hasClass("selectpicker")) {
          $searchInput.selectpicker();
        }
        $html.focus();
        $html.addClass("data-grid-added-search");
        $html.attr("data-grid-session-id", dataGrid.id);
        dataGridHelper.bindSearchElements(dataGrid, $searchInput);
      }, error: function(response) {
        if (response.statusText !== "abort") {
          console.log("Ajax error, response:");
          console.log(response);
        }
      }
    });
  };

  this.initVars($dataGridElem);

  /*
  *
  * Search function
  *
  * */
  this.search = function(pageNum) {
    var defaultPage = 1;
    if (this.defaultToLastPage) {
      defaultPage = parseInt(this.totalPages);
    }
    pageNum  = pageNum || defaultPage;
    var data = this.gatherVars();

    data[this.sessionIdVarName] = this.id;
    if (parseInt(pageNum) !== defaultPage) {
      data[this.pageName] = pageNum;
    }

    this.updateUrl(data);

    if (!this.beforeSearch(data)) {
      return true;
    }
    if (this.ajaxUrl.length < 1) {
      return false;
    }

    this.searchAjaxRequests.forEach(function(thisAjaxRequest) {
      thisAjaxRequest.abort();
    });
    this.searchAjaxRequests = [];

    dataGrid.wrapper.find(".data-grid-corner-refresh").hide();
    dataGrid.wrapper.find(".data-grid-corner-display-settings").hide();
    dataGrid.wrapper.find(".data-grid-corner-loader").show();
    var $floatLoader = $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "']");
    $floatLoader.show();

    if (dataGrid.scrollAboveGridAtStart) {
      dataGrid.ensureTopOfGridIsVisible();
    }

    var $allCheckboxes = dataGrid.wrapper.find(".data-grid-checkbox-row");
    $allCheckboxes.prop("checked", false);
    $($allCheckboxes[0]).change();
    // don't allow opening of any modals that are about to get reset!
    dataGrid.wrapper.find(".modal").each(function() {
      $(this).modal("hide");
    });
    dataGrid.wrapper.find("[data-toggle='modal']").css({"visibility": "hidden"});

    var ajaxRequest = $.ajax({
      url     : this.ajaxUrl,
      type    : "POST",
      data    : data,
      success : function(response) {
        var dataGridHTML = response.datagrid;
        var sortButtons  = response.sortButtons;
        var fieldName;
        for (fieldName in sortButtons) {
          if (sortButtons.hasOwnProperty(fieldName)) {
            //return " data-grid-button-sort='yes' data-grid-field='" . $sort . "' ";
            var $newSortButton = $(sortButtons[fieldName]);
            $newSortButton.click(dataGridHelper.sortButtonClick);
            $("[data-grid-button-sort='yes'][data-grid-field='" + fieldName + "']").find(".data-grid-sort").replaceWith($newSortButton);
          }
        }
        if (!dataGrid.afterSearch(dataGridHTML, data)) {
          $floatLoader.hide();
          return true;
        }
        var $newGrid = $(dataGridHTML);
        var $oldGrid = $(".data-grid-wrapper[data-grid-session-id='" + dataGrid.id + "']");
        if (typeof $oldGrid.data("sticky_header") !== "undefined") {
          deleteStickyHeader($oldGrid);
        }
        $oldGrid.replaceWith($newGrid);
        var existingDataGridObj = dataGrid;
        // 2019.08.12-TSO: Why was I getting the datagrid object from the ID, when we already have it?
        // var existingDataGridObj = getDataGrid(dataGrid.id, "id");

        if (existingDataGridObj === false) {
          var newDataGridObj = new DataGrid($newGrid);
          newDataGridObj.ensureSingleFloatingLoader();
          if (!dataGrid.scrollAboveGridAtStart) {
            newDataGridObj.ensureTopOfGridIsVisible();
          }
        }
        else {
          existingDataGridObj.initVars($newGrid);
          existingDataGridObj.initBindings($newGrid);
          existingDataGridObj.ensureSingleFloatingLoader();
          if (!dataGrid.scrollAboveGridAtStart) {
            existingDataGridObj.ensureTopOfGridIsVisible();
          }
        }
        dataGrid.afterDraw();

        $floatLoader.hide();
      }, error: function(response) {
        if (response.statusText !== "abort") {
          console.log("Ajax error, response:");
          console.log(response);
        }
        $floatLoader.hide();
        dataGrid.wrapper.find(".data-grid-corner-loader").hide();
        dataGrid.wrapper.find(".data-grid-corner-refresh").show();
      }
    });

    this.searchAjaxRequests.push(ajaxRequest);
    return true;
  };
  /*
  *
  * End of search function
  *
  * */
  this.gatherVars = function() {
    var output = {};
    $(".data-grid-input[data-grid-session-id='" + this.id + "']").each(function() {
      var field     = $(this).attr("name");
      var value     = "";
      var inputType = $(this).attr("type");
      if ((inputType !== "checkbox" && inputType !== "radio") || $(this).is(":checked")) {
        value = $(this).val();
      }


      var $shortcutButtons = $("[data-grid-button-search='yes'][data-grid-field='" + field + "']").removeClass("active");
      $shortcutButtons.filter("[data-grid-search-value='" + value + "']").addClass("active");
      if ($(this).val().length > 0 || $(this).attr("data-has-default") === "yes") {

        if ((inputType !== "checkbox" && inputType !== "radio") || $(this).is(":checked")) {
          output[field] = value;
        }
      }
    });
    output[this.pageSizeName]  = $(".data-grid-page-size-select[data-grid-session-id='" + this.id + "']").val();
    output["dataGridGlobalId"] = this.wrapper.attr("data-grid-global-id");
    if (typeof this.addAdditionalSearch === "function") {
      output["additionalSearch"] = this.addAdditionalSearch();
    }
    return output;
  };

  // Only scroll up, never down....
  this.ensureTopOfGridIsVisible   = function() {
    if (!this.scrollAboveGrid) {
      return true;
    }
    var $scrollParent = dataGridHelper.getScrollParent(this.wrapper[0]);
    if (!$scrollParent.length) {
      return true;
    }

    var topElement = false;
    if ($scrollParent.is("html")) {
      topElement = true;
      if (parseInt($scrollParent.scrollTop()) === 0) {
        $scrollParent = $("body");
      }
    }

    var topOfGrid = this.wrapper.offset().top - $scrollParent.offset().top;

    if (!topElement) {
      topOfGrid += $scrollParent.scrollTop();
    }

    var topOfView = $scrollParent.scrollTop();


    if (topOfView > topOfGrid) {
      var newScroll = topOfGrid - this.scrollAboveGridPixels;
      if (this.scrollAboveGridAnimate) {
        $scrollParent.stop().animate({scrollTop: newScroll}, 500, 'swing');
      }
      else {
        $scrollParent.scrollTop(newScroll);
      }

    }
  };
  this.ensureSingleFloatingLoader = function() {
    var $floaterAlreadySelected = $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "'][data-grid-current-loader='yes']");
    var $floatLoaders           = $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "']");
    if ($floaterAlreadySelected.length) {
      $floatLoaders.not($floaterAlreadySelected).remove();
      return $floaterAlreadySelected;
    }

    var $return = null;
    var first   = true;
    $floatLoaders.each(function() {
      if (first) {
        $return = $(this).attr("data-grid-current-loader", "yes");
        first   = false;
        return true;
      }
      $(this).remove();
    });
    return $return;
  };
  this.pullFloatingLoader         = function() {
    return this.ensureSingleFloatingLoader().detach();
  };
  this.removeFloatLoader          = function() {
    $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "']").remove();
  };
  this.resetInput                 = function($input) {
    $input.each(function() {

      if ($(this).hasClass("data-grid-hidden-checkbox-input")) {
        return true;
      }

      var inputType    = $(this).attr("type");
      var defaultValue = $(this).attr("data-grid-default-value");

      if (typeof defaultValue === "undefined" || defaultValue.length < 1) {
        defaultValue = "";
      }
      if ((inputType === "checkbox" || inputType === "radio")) {
        if (defaultValue === $(this).val()) {
          $(this).prop("checked", true).change();
        }
        else {
          $(this).prop("checked", false).change();
        }
        return true;
      }

      $(this).val(defaultValue).change();
    });
  };
  this.reset                      = function() {
    $(".data-grid-input[data-grid-session-id='" + this.id + "']").each(function() {
      dataGrid.resetInput($(this));
    });
    $(".data-grid-added-search[data-grid-session-id='" + this.id + "']").each(function() {
      if ($(this).hasClass("selectpicker")) {
        var $wrapper = $(this).closest(".bootstrap-select");
        if ($wrapper.length) {
          $wrapper.remove();
          return true;
        }
      }
      $(this).remove();
    });
    return this;
  };
  this.updateUrl                  = function(data) {

    if (!this.updateUrlEnabled) {
      return true;
    }

    var skipVars = [this.sessionIdVarName, this.pageSizeName, this.hiddenVarsName, "dataGridGlobalId", "additionalSearch"];

    $("input[data-grid-skip-url='yes'][data-grid-session-id='" + this.id + "']").each(function() {
      skipVars.push($(this).attr("name"));
    });

    var url   = window.location.href.split("?")[0] + "?";
    var first = true;
    var property;
    for (property in data) {
      if (data.hasOwnProperty(property)) {
        if (skipVars.indexOf(property) > -1) {
          continue;
        }

        if (!first) {
          url += "&";
        }
        first = false;
        url += encodeURIComponent(property) + "=" + encodeURIComponent(data[property]);
      }
    }

    window.history.pushState({dataGrid: "yes", mode: "search"}, document.title, url);
    // use this to avoid affecting browser history
    // window.history.replaceState({}, document.title, url);

    return true;
  };
  this.initBindingsInRows         = function($wrapper) {
    dataGridHelper.bindCheckboxes(this, $wrapper);
    dataGridHelper.bindChildRowControlElements(this, $wrapper);
    dataGridHelper.bindLinkElements(this, $wrapper);
    dataGridHelper.bindGears($wrapper);
    dataGridHelper.bindAdditional(this, $wrapper);
    if (this.openOnClick) {
      dataGridHelper.bindRows(this, $wrapper);
    }
  };
  this.initBindings               = function($dataGridElem) {

    dataGridHelper.bindPaginationAjax(this, $dataGridElem);
    dataGridHelper.bindPageSizeSelect(this, $dataGridElem);
    dataGridHelper.bindSortElements(this, $dataGridElem);
    dataGridHelper.bindRefreshElements(this, $dataGridElem);

    dataGridHelper.bindSearchElements(this);
    dataGridHelper.bindAddSearchButtons(this);
    dataGridHelper.bindSearchForm(this);


    dataGridHelper.bindCookieButtons(this, $dataGridElem);
    if (this.stickyHeader && typeof StickyHeader === "function") {
      new StickyHeader($dataGridElem, this.stickyHeaderZIndex, this.scrollParentSelector, this.wrapper.find(".data-grid-horizontal-scroll"));
    }

    this.initBindingsInRows($dataGridElem);
  };
  this.row                        = function(row_id) {
    return dataGridHelper.getRowData(this.wrapper.find("tr[data-row-id='" + row_id + "']"));
  };
  this.rowElem                    = function(row_id) {
    return this.wrapper.find("tr[data-row-id='" + row_id + "']");
  };
  this.data                       = function() {
    if (this.$selectedRow === null) {
      return false;
    }
    return dataGridHelper.getRowData(this.$selectedRow);
  };
  this.value                      = function(value) {
    if (this.$selectedRow === null) {
      return false;
    }
    return dataGridHelper.getRowDataValue(this.$selectedRow, value);
  };
  this.rowValue                   = function(row_id, value) {
    return dataGridHelper.getRowDataValue(this.wrapper.find("tr[data-row-id='" + row_id + "']"), value);
  };
  this.getRowNum                  = function(rowNum, formatted) {
    rowNum--;
    return dataGridHelper.getRowData(this.wrapper.find("tbody.data-grid-tbody:eq(" + rowNum + ")"), formatted);
  };
  this.getRowNumElem              = function(rowNum) {
    rowNum--;
    return this.wrapper.find("tbody.data-grid-tbody:eq(" + rowNum + ")");
  };
  this.getRowNumValue             = function(rowNum, value) {
    rowNum--;
    return dataGridHelper.getRowDataValue(this.wrapper.find("tbody.data-grid-tbody:eq(" + rowNum + ")"), value);
  };
  this.getRows                    = function() {
    var $rows  = this.wrapper.find("tbody.data-grid-tbody");
    var output = [];
    $rows.each(function() {
      output.push(dataGridHelper.getRowData($(this)));
    });

    return output;

  };
  this.addRowDetail               = function(rowID, detail, rowClass, clearPreviousDetails) {
    if (typeof clearPreviousDetails !== 'boolean') {
      if (clearPreviousDetails === "false") {
        clearPreviousDetails = false;
      }
      else {
        clearPreviousDetails = true;
      }
    }
    if (typeof rowClass !== "string") {
      rowClass = "";
    }
    var $row = this.wrapper.find("tbody[data-row-id='" + rowID + "']");
    if (!$row.length) {
      return true;
    }
    var colNum = 0;
    $row.find("tr:first").find("td,th").each(function() {
      if ($(this).hasClass("data-grid-expand-with-child")) {
        return true;
      }
      if ($(this).css("display") === "none") {
        return true;
      }
      var colspan = $(this).attr("colspan");
      if (typeof colspan !== "undefined" && colspan > 0) {
        colNum += parseInt(colspan);
      }
      else {
        colNum += 1;
      }
    });
    var numToRemove = 0;
    if (clearPreviousDetails) {
      var $previousDetails = $row.find(".data-grid-row-detail");
      numToRemove          = $row.length;
      $previousDetails.remove();

    }
    $row.find(".data-grid-last-row-in-tbody").removeClass("data-grid-last-row-in-tbody");
    $row.append("<tr class='data-grid-last-row-in-tbody data-grid-row-detail " +
                // rowClass +
                "'><td colspan='" +
                colNum +
                "'><div style='width: 100%;' class='" + rowClass + "'>" +
                detail +
                "</div></td></tr>");
    $row.find(".data-grid-expand-with-child").each(function() {
      var currentRowSpan = $(this).attr("rowspan");
      $(this).attr("rowspan", currentRowSpan + 1 - numToRemove);
    });


  };
  this.removeRowDetail            = function(rowID) {
    var $row      = this.wrapper.find("tbody[data-row-id='" + rowID + "']");
    var $toRemove = $row.find(".data-grid-row-detail");
    if (!$toRemove.length) {
      return true;
    }
    $toRemove.remove();
    var $childRow = $row.find(".data-grid-row-child").addClass("data-grid-last-row-in-tbody");


    if ($childRow.attr("data-visible") === "yes") {
      return true;
    }
    $row.find("tr.data-grid-row-sub-row:last").addClass("data-grid-last-row-in-tbody");
  };

  this.replaceRow = function(rowID, content) {
    var $row = this.wrapper.find(".data-grid-tbody[data-row-id='" + rowID + "']");
    if (!$row.length) {
      return false;
    }

    $newRow = $(content);

    $row.replaceWith($newRow);

    if (typeof gearJS !== "undefined") {
      gearJS.auto($newRow);
    }
    this.initBindingsInRows($newRow);

    $newRow.find(".data-grid-checkbox-row").trigger("change");
    return $newRow;
  };

  this.checkedRows = function() {
    var output = [];
    this.wrapper.find(".data-grid-checkbox-row:checked").each(function() {
      output.push($(this).attr("data-row-id"));
    });
    return output;
  };

  this.checkedRowsWithValue = function(field, value) {
    var output = [];
    this.wrapper.find(".data-grid-checkbox-row:checked").each(function() {
      if ($(this).dataGrid().value(field) === value) {
        output.push($(this).attr("data-row-id"));
      }
    });
    return output;
  };

  this.closeRow = function() {
    var $hideOnOpen;
    if (dataGrid.openHide === "_grid") {
      $hideOnOpen = $wrapper;
    }
    else {
      $hideOnOpen = $(dataGrid.openHide);
    }
    dataGrid.$open.hide();
    dataGrid.rowOpen = false;
    $hideOnOpen.show();
    if (dataGrid.$rememberScrollDiv !== null) {
      dataGrid.$rememberScrollDiv.scrollTop(dataGrid.rememberScroll);
    }
    dataGrid.onCloseFunctions.forEach(function(onCloseFunction) {
      onCloseFunction(dataGrid);
    });
  };

  this.openRow      = function($row, mode, blank) {

    mode  = mode || null;
    blank = blank || false;

    // turned out to be more complicated than anticipated... pushing states is fine, but it's impossible to delete them....
    // window.history.pushState({dataGrid: "yes", mode: "openRow"}, document.title, window.location.href);
    var $hideOnOpen;
    var $scrollParent = dataGridHelper.getScrollParent(dataGrid.wrapper[0]);
    dataGrid.$open.find("[data-grid-open-mode-required='yes']").hide().each(function() {

      var thisMode = JSON.parse($(this).attr("data-grid-mode"));
      if (thisMode === mode || ($.isArray(thisMode) && $.inArray(mode, thisMode) !== -1)) {
        $(this).show();
      }
    });
    if ($scrollParent.is("html")) {
      if (parseInt($scrollParent.scrollTop()) === 0) {
        $scrollParent = $("body");
      }
    }
    if (dataGrid.openHide === "_grid") {
      $hideOnOpen = $wrapper;
    }
    else {
      $hideOnOpen = $(dataGrid.openHide);
    }

    dataGrid.rememberScroll     = $scrollParent.scrollTop();
    dataGrid.$rememberScrollDiv = $scrollParent;
    dataGrid.startOpenRow($row, mode, blank);
    if (dataGrid.$open.find("[data-grid-open-row-detail='yes'][data-grid-load='yes']").length) {
      if (!blank) {
        dataGrid.openRowAjax($row, mode);
      }
    }
    $hideOnOpen.hide();
    dataGrid.$open.css("display", "flex");
    dataGrid.rowOpen = true;
    if (blank) {
      dataGrid.$open.data("row", "blank");
    }
    else {
      dataGrid.$open.data("row", $row);
    }

    $scrollParent.scrollTop(dataGrid.$open.offset().top - 100);
    dataGrid.onOpenFunctions.forEach(function(onOpenFunction) {
      onOpenFunction(dataGrid);

    });

    dataGridHelper.bindGears(dataGrid.$open);

    return dataGrid;
  };
  this.startOpenRow = function($row, mode, blank) {
    blank = blank || false;
    var row;
    var formattedRow;
    if (blank) {
      row          = {};
      formattedRow = {};
    }
    else {
      row          = dataGridHelper.getRowData($row);
      formattedRow = dataGridHelper.getRowData($row, true);
    }

    var $loader = dataGrid.$open.find(".data-grid-open-row-ajax-loader:last");
    var $tabs   = dataGrid.$open.find(".data-grid-open-tab");
    if ($tabs.length) {
      $tabs.removeClass("active");
      var $activeTab = $tabs.filter("[data-grid-tab-mode='" + mode + "']");
      if (!$activeTab.length) {
        $activeTab = $tabs.filter("[data-grid-tab-default='yes']");
      }
      if ($activeTab.length) {
        $activeTab.addClass("active");

      }
    }
    dataGrid.$open.find("[data-grid-open-row-hide-empty='yes']").each(function() {
      var rowToPullFrom = row;
      if ($(this).attr("data-grid-formatted") === "yes") {
        rowToPullFrom = formattedRow;
      }
      var fieldToCheck = $(this).attr("data-grid-field");
      if (rowToPullFrom[fieldToCheck].trim().length < 1) {
        $(this).hide();
      }
      else {
        $(this).show();
      }
    });
    dataGrid.$open.find("[data-grid-open-row-hide-not-empty='yes']").each(function() {
      var rowToPullFrom = row;
      if ($(this).attr("data-grid-formatted") === "yes") {
        rowToPullFrom = formattedRow;
      }
      var fieldToCheck = $(this).attr("data-grid-field");
      if (rowToPullFrom[fieldToCheck].trim().length < 1) {
        $(this).show();
      }
      else {
        $(this).hide();
      }
    });
    dataGrid.$open.find("[data-grid-open-row-hide-if-same='yes']").each(function() {
      var rowToPullFrom = row;
      if ($(this).attr("data-grid-formatted") === "yes") {
        rowToPullFrom = formattedRow;
      }
      var fieldA = $(this).attr("data-grid-field-a");
      var fieldB = $(this).attr("data-grid-field-b");
      if (typeof rowToPullFrom[fieldA] === "undefined" || typeof rowToPullFrom[fieldB] === "undefined") {
        if ((typeof rowToPullFrom[fieldA] === "undefined" || rowToPullFrom[fieldA].length < 1) &&
            (typeof rowToPullFrom[fieldB] === "undefined" || rowToPullFrom[fieldB].length < 1)) {
          $(this).hide();
        }
        else {
          $(this).show();
        }
      }
      if (rowToPullFrom[fieldA] === rowToPullFrom[fieldB]) {
        $(this).hide();
      }
      else {
        $(this).show();
      }
    });
    dataGrid.$open.find("[data-grid-open-row-detail='yes'][data-grid-load='no']").each(function() {
      var rowToPullFrom = row;
      var newValue;
      var field         = $(this).attr("data-grid-field");

      if ($(this).attr("data-grid-source") === "field") {
        if ($(this).attr("data-grid-formatted") === "yes") {
          rowToPullFrom = formattedRow;
        }

        if (typeof rowToPullFrom[field] === "undefined" || rowToPullFrom[field].length < 1) {
          newValue = "";
        }
        else {
          newValue = rowToPullFrom[field];
        }
      }
      else {
        var data = dataGrid.gatherVars();
        newValue = data[field];
      }

      if ($(this).attr("data-grid-first-upper") === "yes") {
        newValue = newValue.charAt(0).toUpperCase() + newValue.slice(1);
      }

      var attrName = $(this).attr("data-grid-attr");

      if (typeof newValue === "undefined" || newValue.length < 1) {
        newValue = $(this).attr("data-grid-default-value");
      }

      if (typeof attrName === "undefined" || attrName.length < 1 || attrName === "html") {
        if ($(this).attr("data-grid-raw") === "no") {
          $(this).text(newValue);
        }
        else {
          $(this).html(newValue);
        }
      }
      else {
        if (attrName === "value") {
          $(this).val(newValue);
        }
        else if (attrName === "summernote") {
          $(this).summernote("code", newValue);
        }
        else if (attrName === "checked") {
          if (newValue === $(this).attr("data-grid-check-if")) {
            $(this).prop("checked", true);
          }
          else {
            $(this).prop("checked", false);
          }
        }
        else {
          $(this).attr(attrName, newValue);
        }

      }

    });

    dataGrid.$open.find("[data-grid-open-row-detail='yes'][data-grid-load='yes']").each(function() {
      var loader     = $(this).attr("data-grid-open-loader") === "yes";
      var loaderSize = $(this).attr("data-grid-open-loader-size");
      if (loader && !blank) {
        var $replace = $loader.clone().show();

        if (loaderSize > 0) {
          $replace.css({"font-size": loaderSize + "px"});
          $replace.find("*").css({"font-size": loaderSize + "px"});
        }
        $(this).html($replace);
      }
      else {
        $(this).html("");
      }
    });
  };

  this.openRowAjax = function($row, mode) {
    var row = dataGridHelper.getRowData($row);
    if (typeof mode !== 'undefined' && mode !== null) {
      row._mode = mode;
    }
    dataGrid.openAjaxRequests.forEach(function(thisAjaxRequest) {
      thisAjaxRequest.abort();
    });
    dataGrid.openAjaxRequests = [];
    var ajaxRequest           = $.ajax({
      url     : dataGrid.ajaxOpenUrl,
      type    : "POST",
      data    : row,
      success : function(response) {
        dataGrid.$open.find("[data-grid-open-row-detail='yes'][data-grid-load='yes']").each(function() {
          var field = $(this).attr("data-grid-field");
          if (typeof response[field] === "undefined" || response[field] === null || response[field].length < 1) {
            $(this).html("");
            return true;
          }

          var $divToChange              = $(this);
          var $iframe                   = null;
          var $viewOnWhiteBackgroundDiv = "";
          var $beforeIframe             = "";

          if ($(this).attr("data-grid-in-iframe") === "yes" && response._iframe[field].cancel !== true) {
            if (response._iframe[field].viewOriginalOption === true) {
              $viewOnWhiteBackgroundDiv = $("<a href='javascript:void(0)'>View original</a>");
              $beforeIframe             = $("<div class='alert alert-warning'></div>");
              $beforeIframe.html("The background and text colors have been modified to fit your theme. ");
              $beforeIframe.append($viewOnWhiteBackgroundDiv);
              $beforeIframe.append("<br>");
            }
            else {
              $beforeIframe = "";
            }
            $iframe = $("<iframe style='width: 100%; border: none;'></iframe>");
            $(this).html($beforeIframe);
            $(this).append($iframe);
            $divToChange = $iframe.contents().find("body");
            $iframe.on("load", function(e) {
              dataGridHelper.iFrameOnLoadMethod($iframe, response, field);
            });
            if (response._iframe[field].viewOriginalOption === true) {
              $viewOnWhiteBackgroundDiv.click(function() {
                $(this).parent().remove();
                $iframe.css("background", "white");
                var $divToChange   = $iframe.contents().find("body");
                var originalStyles = $divToChange.data("originalStyles");
                var styleName;
                for (styleName in originalStyles) {
                  if (originalStyles.hasOwnProperty(styleName)) {
                    $divToChange.css(styleName, originalStyles[styleName]);
                  }
                }

              });
            }
            // adding a "src" breaks ie + edge... about:blank is apparently a "different domain". :P
            if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {
              // must give a 'src' or chrome doesn't fire the 'onload' event....
              $iframe.attr("src", "about:blank");
            }
            return true;
          }

          var newValue = response[field];
          if (typeof newValue === "undefined" || newValue.length < 1) {
            newValue = $(this).attr("data-grid-default-value");
          }

          if ($(this).attr("data-grid-raw") === "no") {
            $divToChange.text(newValue);

          }
          else {
            $divToChange.html(newValue);
          }


        });
        dataGridHelper.bindGears(dataGrid.$open);
      }, error: function(response) {
        if (response.statusText !== "abort") {
          console.log("Ajax error, response:");
          console.log(response);
        }
      }
    });
    dataGrid.openAjaxRequests.push(ajaxRequest);

  };

  this.initBindings($dataGridElem);
  dataGridHelper.removeDuplicate(this.id);
  allDataGrids.push(this);
};


var dataGridHelper = {
  iFrameOnLoadMethod: function($iframe, response, field) {
    var iFrameDocument = ($iframe[0].contentWindow || $iframe[0].contentDocument);
    if (iFrameDocument.location.href === "about:blank") {
      var $divToChange = $iframe.contents().find("body");
      if ($(this).attr("data-grid-raw") === "no") {
        $divToChange.text(response[field]);
      }
      else {
        $divToChange.html(response[field]);
      }
    }
    var styleName;
    var originalStyles = {};
    if (typeof response._iframe !== 'undefined' && typeof response._iframe[field] !== "undefined") {
      if (typeof response._iframe[field].style === "object" && response._iframe[field].style !== null) {
        for (styleName in response._iframe[field].style) {
          if (response._iframe[field].style.hasOwnProperty(styleName)) {
            originalStyles[styleName] = $divToChange.css(styleName);
            $divToChange.css(styleName, response._iframe[field].style[styleName]);
          }
        }
      }
    }
    if (typeof $divToChange.data("originalStyles") === "undefined" || $divToChange.data("originalStyles").length < 1) {
      $divToChange.data("originalStyles", originalStyles);
    }

    if (typeof iFrameResize === "function") {
      iFrameResize($iframe);
    }
    else {
      console.log("iFrameResize function not found. Install 'skeets.iframe-resize' through npm.");
    }
  },

  boundPopState              : false,
  $resizingColumn            : null,
  allowSorting               : true,
  saveGridColWidth           : function(field) {
    var dataGrid   = dataGridHelper.$resizingColumn.dataGrid();
    var cookieName = dataGrid.name + "_" + "col_width_" + field;
    var $cell      = dataGrid.wrapper.find("th[data-field='" + field + "']");
    if (!$cell.length) {
      $cell = dataGrid.wrapper.find("td[data-match-width='" + field + "']");
    }
    var cookieValue = $cell.outerWidth();
    Cookies.set(cookieName, cookieValue, {expires: 36500});
  },
  dataGridColumnMouseMove    : function(e) {
    if (!dataGridHelper.$resizingColumn.length) {
      dataGridHelper.dataGridColumnMouseUp();
      return true;
    }
    var dataGrid     = dataGridHelper.$resizingColumn.dataGrid();
    var widthInverse = dataGridHelper.$resizingColumn.attr("data-width-inverse");
    var inverseMode  = false;
    if (typeof widthInverse !== "undefined" && widthInverse.length > 0) {
      inverseMode = true;
    }

    var newWidth = e.pageX - dataGridHelper.$resizingColumn.offset().left + 5 + (parseInt(dataGridHelper.$resizingColumn.css("padding-left")));
    var field    = dataGridHelper.$resizingColumn.attr("data-field");
    var $column  = dataGrid.wrapper.find("td[data-match-width='" + field + "']");
    if (newWidth < 50) {
      newWidth = 50;
    }
    var oldWidth = dataGridHelper.$resizingColumn.outerWidth();
    if (!inverseMode) {
      dataGridHelper.$resizingColumn.css({width: newWidth, "max-width": newWidth, "min-width": newWidth});
      $column.css({width: newWidth, "max-width": newWidth, "min-width": newWidth});
    }
    else {
      var changeWidthBy = oldWidth - newWidth;
      if (newWidth < parseInt(dataGridHelper.$resizingColumn.css("min-width"))) {
        return true;
      }

      var $targetColumn = dataGrid.wrapper.find("td[data-match-width='" + widthInverse + "']");
      var $targetHeader = dataGrid.wrapper.find("th[data-field='" + widthInverse + "']");
      var targetNewWidth;
      if ($targetHeader.length) {
        targetNewWidth = $targetHeader.outerWidth() + changeWidthBy;
      }
      else {
        targetNewWidth = $targetColumn.outerWidth() + changeWidthBy;
      }
      if (targetNewWidth < 50) {
        targetNewWidth = 50;
      }
      $targetHeader.css({width: targetNewWidth, "max-width": targetNewWidth, "min-width": targetNewWidth});
      $targetColumn.css({width: targetNewWidth, "max-width": targetNewWidth, "min-width": targetNewWidth});
    }

  },
  dataGridColumnMouseUp      : function() {
    var field        = dataGridHelper.$resizingColumn.attr("data-width-inverse");
    var widthInverse = dataGridHelper.$resizingColumn.attr("data-width-inverse");
    if (typeof widthInverse === "undefined" || widthInverse.length < 1) {
      field = dataGridHelper.$resizingColumn.attr("data-field");
    }
    $(document).off("mousemove", dataGridHelper.dataGridColumnMouseMove);
    $(document).off("mouseup", dataGridHelper.dataGridColumnMouseUp);
    dataGridHelper.saveGridColWidth(field);
    // only way to prevent this from triggering the sort on release of mouse button...
    dataGridHelper.allowSorting = false;
    setTimeout(function() {
      dataGridHelper.allowSorting = true;
    }, 100);
  },
  getScrollParent            : function(element) {
    var style               = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";

    if (style.position === "fixed") {
      return $("html");
    }
    for (var parent = element; (parent = parent.parentElement);) {
      style = getComputedStyle(parent);
      if (excludeStaticParent && style.position === "static") {
        continue;
      }
      if (/(auto|scroll)/.test(style.overflow + style.overflowY) && parent.scrollHeight > parent.clientHeight) {
        return $(parent);
      }
    }

    return $("html");
  },
  checkDataGrids             : function() {
    var index = allDataGrids.length - 1;
    while (index >= 0) {
      if (!document.body.contains(allDataGrids[index].wrapper[0])) {
        allDataGrids[index].removeFloatLoader();
        allDataGrids.splice(index, 1);
      }

      index -= 1;
    }

  },
  getRowData                 : function($row, formatted) {
    if (typeof formatted === "undefined" || formatted !== true) {
      formatted = false;
    }
    var output = {};
    $row.find(".data-grid-data-single").each(function() {
      var value = dataGridHelper.getCellValue($(this), formatted);

      output[$(this).attr("data-grid-field")] = value;
    });
    output["row_id"] = $row.attr("data-row-id");
    return output;
  },
  getRowDataValue            : function($row, value) {
    if (value === "row_id") {
      return $row.attr("data-row-id");
    }

    var $cell = $row.find(".data-grid-data-single[data-grid-field=" + value + "]");
    if (!$cell.length) {
      return false;
    }
    return dataGridHelper.getCellValue($cell);
  },
  showChildRow               : function($row) {
    $row.find(".data-grid-row-child").attr("data-visible", "yes").show();
    $row.find(".data-grid-hide-child-row").show();
    $row.find(".data-grid-show-child-row").hide();
    if (!$row.find(".data-grid-row-detail").length) {
      $row.find(".data-grid-last-row-in-tbody:not(.data-grid-row-child)").removeClass("data-grid-last-row-in-tbody");
    }

    $row.find(".data-grid-expand-with-child").each(function() {
      var currentRowSpan = $(this).attr("rowspan");
      $(this).attr("rowspan", currentRowSpan + 1);
    });
    if (typeof stickyHeaderResize === 'function') {
      stickyHeaderResize($row.closest(".data-grid-wrapper"));
    }

    return true;
  },
  hideChildRow               : function($row) {
    $row.find(".data-grid-row-child").attr("data-visible", "no").hide();
    $row.find(".data-grid-show-child-row").show();
    $row.find(".data-grid-hide-child-row").hide();
    if (!$row.find(".data-grid-row-detail").length) {
      $row.find("tr.data-grid-row-sub-row:last").addClass("data-grid-last-row-in-tbody");
    }
    $row.find(".data-grid-expand-with-child").each(function() {
      var currentRowSpan = $(this).attr("rowspan");
      $(this).attr("rowspan", currentRowSpan - 1);
    });
    if (typeof stickyHeaderResize === 'function') {
      stickyHeaderResize($row.closest(".data-grid-wrapper"));
    }
    return true;
  },
  toggleChildRow             : function($row) {
    if ($row.find(".data-grid-row-child").attr("data-visible") === "yes") {
      this.hideChildRow($row);
    }
    else {
      this.showChildRow($row);
    }
    return true;
  },
  getCellValue               : function($cell, formatted) {
    if (typeof formatted === "undefined" || formatted !== true) {
      formatted = false;
    }
    if (formatted) {
      var $inner = $cell.find(".data-grid-cell-inner");
      if ($inner.length) {
        return $inner.html().trim();
      }
      return $cell.html().trim();
    }
    var value = $cell.attr("data-grid-value");
    if (value.length < 1) {
      value = $cell.text().trim();
    }
    return value;
  },
  removeDuplicate            : function(id) {
    allDataGrids.forEach(function(dataGrid, index, array) {
      if (dataGrid.id === id) {
        array.splice(index, 1);
      }
    });
  },
  getDataGrid                : function(id) {
    var output = null;
    allDataGrids.forEach(function(dataGrid) {
      if (dataGrid.id === id) {
        output = dataGrid;
        return false;
      }
    });
    return output;
  },
  bindPaginationAjax         : function(dataGrid, $dataGridElem) {
    $dataGridElem.find(".data-grid-pagination-wrapper").on("click", "a", function(e) {
      var page = $(this).attr("data-grid-page");
      if (typeof page === "undefined" || page.length < 1) {
        return true;
      }
      if (dataGrid.search(page)) {
        e.preventDefault();
      }


    });
  },
  bindPageSizeSelect         : function(dataGrid, $dataGridElem) {
    $dataGridElem.find(".data-grid-page-size-select").on("change", function(e) {
      var pageSize = $(this).val();
      if (typeof pageSize === "undefined" || pageSize.length < 1) {
        return true;
      }
      if (dataGrid.search()) {
        e.preventDefault();
      }


    });
  },
  bindCheckboxes             : function(dataGrid, $dataGridElem) {
    var $checkAll = $dataGridElem.find(".data-grid-check-all");
    $checkAll.on("change", function(e) {
      var $allCheckboxes = dataGrid.wrapper.find(".data-grid-checkbox-row");
      if ($(this).is(":checked")) {
        $allCheckboxes.prop("checked", true);
      }
      else {
        $allCheckboxes.prop("checked", false);
      }

      $($allCheckboxes[0]).change();


    });
    $dataGridElem.find(".data-grid-checkbox-row").on("change", function(e) {
      var numChecked = dataGrid.wrapper.find(".data-grid-checkbox-row:checked").length;
      dataGrid.wrapper.find(".data-grid-num-checked-disp").html(numChecked);
      if (numChecked) {
        $checkAll.prop("checked", true);
        dataGrid.wrapper.find(".data-grid-header-bulk-hide").hide();
        dataGrid.wrapper.find(".data-grid-header-bulk-show").show();
        if (typeof stickyHeaderResize === 'function') {
          stickyHeaderResize(dataGrid.wrapper);
        }
      }
      else {
        $checkAll.prop("checked", false);
        dataGrid.wrapper.find(".data-grid-header-bulk-show").hide();
        dataGrid.wrapper.find(".data-grid-header-bulk-hide").show();
        if (typeof stickyHeaderResize === 'function') {
          stickyHeaderResize(dataGrid.wrapper);
        }
      }
    });
    $dataGridElem.find(".data-grid-checkbox-row-wrapper").click(function(e) {
      if ($(e.target).is("input")) {
        return true;
      }
      var $checkbox = $(this).find("input");
      $checkbox.prop("checked", !$checkbox.prop("checked"));
      $checkbox.change();
    });
  },
  addAdditionalBinding       : function(dataGrid, settings) {
    dataGridHelper.bindAdditionalSingle(dataGrid, settings, dataGrid.wrapper);
    dataGrid.additionalBindingFunctions.push(settings);
  },
  bindRefreshElements        : function(dataGrid, $dataGridElem) {
    $dataGridElem.find(".data-grid-corner-refresh").on("click", function(e) {
      if (dataGrid.search()) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  },
  bindChildRowControlElements: function(dataGrid, $dataGridElem) {
    $dataGridElem.find(".data-grid-show-child-row").on("click", function(e) {
      dataGridHelper.showChildRow($(this).closest("tbody"));
      e.stopPropagation();
    });
    $dataGridElem.find(".data-grid-hide-child-row").on("click", function(e) {
      dataGridHelper.hideChildRow($(this).closest("tbody"));
      e.stopPropagation();
    });
    $dataGridElem.find(".data-grid-child-row-toggle").on("click", function(e) {
      dataGridHelper.toggleChildRow($(this).closest("tbody"));
      e.stopPropagation();
    });
  },
  bindSortElements           : function(dataGrid, $dataGridElem) {
    $dataGridElem.find(".data-grid-header-cell").off("click", dataGridHelper.sortButtonWrapperClick).click(dataGridHelper.sortButtonWrapperClick);

    $dataGridElem.find(".data-grid-resize-column").on("mousedown", function(e) {
      dataGridHelper.$resizingColumn = $(this).closest("th");
      $(document).on("mousemove", dataGridHelper.dataGridColumnMouseMove);
      $(document).on("mouseup", dataGridHelper.dataGridColumnMouseUp);
    });

    $dataGridElem.find(".data-grid-count-cap-warning-wrapper").on("closed.bs.alert", function() {
      $dataGridElem.find(".data-grid-hide-count-cap-warning-wrapper").show();
    });

    $dataGridElem.find(".data-grid-hide-count-cap-warning").click(function() {
      var cookieNamePiece = "hide_count_cap_warning";
      var cookieName      = dataGrid.name + "_" + cookieNamePiece;
      var cookieValue     = "yes";
      Cookies.set(cookieName, cookieValue, {expires: 36500});
      $(this).closest(".alert").alert("close");
    });


    $dataGridElem.find(".data-grid-sort").on("click", dataGridHelper.sortButtonClick);
  },
  bindLinkElements           : function(dataGrid, $dataGridElem) {
    $dataGridElem.find(".data-grid-change-input").off("click", dataGridHelper.searchButtonClick).click(dataGridHelper.searchButtonClick);
  },


  bindCookieButtons: function(dataGrid, $dataGridElem) {
    $dataGridElem.find(".data-grid-open-settings-dialog").click(function(e) {
      e.preventDefault();
      dataGrid.openSettingsModal();
    });

    if (dataGrid.settingsModal.data("bound") === "yes") {
      return true;
    }
    dataGrid.settingsModal.data("bound", "yes");
    dataGrid.settingsModal.find(".data-grid-download-csv").click(function() {
      window.location = dataGrid.wrapper.attr("data-csv-url");
    });
    dataGrid.settingsModal.find(".data-grid-reset-col-width").click(function(e) {
      dataGrid.wrapper.find(".data-grid-header-cell").each(function() {
        var fieldName  = $(this).attr("data-field");
        var cookieName = dataGrid.name + "_" + "col_width_" + fieldName;
        Cookies.remove(cookieName);
      });
      dataGrid.search();
    });
    dataGrid.settingsModal.find(".data-grid-reset-all-settings").click(function(e) {
      dataGrid.settingsModal.find(".data-grid-reset-col-width").click();
      dataGrid.settingsModal.find(".data-grid-set-cookie-radio").each(function() {
        var cookieNamePiece = $(this).attr("data-grid-cookie");
        Cookies.remove(dataGrid.name + "_" + cookieNamePiece);
      });
      dataGrid.settingsModal.find(".data-grid-set-cookie-checkbox").each(function() {
        var cookieNamePiece = $(this).attr("data-grid-cookie");
        Cookies.remove(dataGrid.name + "_" + cookieNamePiece);
      });
      Cookies.remove(dataGrid.name + "_" + "hide_count_cap_warning");
      dataGrid.settingsModal.find("label.active").removeClass("active");
      dataGrid.settingsModal.find("input[data-grid-cookie='fontsize'][data-grid-cookie-value='" + dataGrid.defaultFontSize + "']")
              .prop("checked", true)
              .closest("label")
              .addClass("active");
      dataGrid.settingsModal.find("input[data-grid-cookie='spacing'][data-grid-cookie-value='" + dataGrid.defaultSpacing + "']")
              .prop("checked", true)
              .closest("label")
              .addClass("active");

      dataGrid.search();
    });
    dataGrid.settingsModal.find(".data-grid-set-cookie-radio").change(function(e) {

      var cookieNamePiece = $(this).attr("data-grid-cookie");
      var cookieName      = dataGrid.name + "_" + cookieNamePiece;
      var cookieValue     = $(this).attr("data-grid-cookie-value");
      Cookies.set(cookieName, cookieValue, {expires: 36500});

      var $table = $(false);

      var dataGrids = getDataGrids(dataGrid.name);

      dataGrids.forEach(function(thisDataGrid) {
        $table = $table.add(thisDataGrid.wrapper.find("table"));
      });

      switch (cookieNamePiece) {
        case "spacing":
          $table.removeClass("data-grid-spacing-narrower");
          $table.removeClass("data-grid-spacing-narrow");
          $table.removeClass("data-grid-spacing-normal");
          $table.removeClass("data-grid-spacing-wide");
          $table.removeClass("data-grid-spacing-wider");
          $table.addClass("data-grid-spacing-" + cookieValue);
          if (typeof stickyHeaderResize === 'function') {
            stickyHeaderResize(dataGrid.wrapper);
          }
          break;
        case "fontsize":
          $table.removeClass("data-grid-fontsize-smaller");
          $table.removeClass("data-grid-fontsize-small");
          $table.removeClass("data-grid-fontsize-normal");
          $table.removeClass("data-grid-fontsize-large");
          $table.removeClass("data-grid-fontsize-larger");
          $table.addClass("data-grid-fontsize-" + cookieValue);
          if (typeof stickyHeaderResize === 'function') {
            stickyHeaderResize(dataGrid.wrapper);
          }
          break;
      }

    });
    dataGrid.settingsModal.find(".data-grid-set-cookie-checkbox").change(function(e) {

      // dataGrid.closeSettingsModal();

      var cookieNamePiece = $(this).attr("data-grid-cookie");
      var cookieName      = dataGrid.name + "_" + cookieNamePiece;
      var cookieValue     = $(this).is(":checked");
      Cookies.set(cookieName, cookieValue, {expires: 36500});

      if ($(this).attr("data-grid-refresh") === "yes") {
        dataGrid.search();
      }


    });

  },


  bindSearchElements    : function(dataGrid, $elem) {

    $elem = $elem || $(".data-grid-search[data-grid-session-id='" + dataGrid.id + "']");
    $elem.each(function() {
      var boundSearch = $(this).data("bound_search");
      if (typeof boundSearch !== "undefined" && boundSearch === true) {
        return true;
      }
      if ($(this).hasClass("dg-datetime-picker")) {
        var format = "YYYY-MM-DD hh:mm a";
        if ($(this).hasClass("dg-datetime-date-no-time")) {
          format = "YYYY-MM-DD";
        }
        $(this).datetimepicker({
          icons        : {
            time    : "fa fa-clock-o",
            date    : "fa fa-calendar",
            up      : "fa fa-arrow-up",
            down    : "fa fa-arrow-down",
            next    : "fa fa-angle-right",
            previous: "fa fa-angle-left"
          },
          keyBinds     : {
            up   : null,
            down : null,
            right: null,
            left : null
          }, useCurrent: false,
          viewDate     : moment(new Date()).hours(0).minutes(0).seconds(0).milliseconds(0),
          format       : format
        }).on("dp.change", function() {
          $(this).keyup();
        });
      }
      var dataGridId = $(this).attr("data-grid-session-id");
      $(this).keyup(function() {
        debounce(function() {
          dataGridHelper.getDataGrid(dataGridId).search();
        });
      });
      $(this).change(function() {
        dataGridHelper.getDataGrid(dataGridId).search();
      });
      $(this).on("search", function() {
        dataGridHelper.getDataGrid(dataGridId).search();
      });
      $(this).data("bound_search", true);
    });
  },
  bindAddSearchButtons  : function(dataGrid, $elem) {

    $elem = $elem || $(".data-grid-add-search-button[data-grid-session-id='" + dataGrid.id + "']");
    $elem.each(function() {
      var boundClick = $(this).data("bound_click");
      if (typeof boundClick !== "undefined" && boundClick === true) {
        return true;
      }
      var dataGridId = $(this).attr("data-grid-session-id");
      $(this).click(function() {
        dataGridHelper.getDataGrid(dataGridId).addSearch($($(this).attr("data-grid-append-target")), $(this).attr("data-grid-field"), $(this)
          .attr("data-grid-operation"));
      });
      $(this).data("bound_search", true);
    });
  },
  bindSearchForm        : function(dataGrid, $elem) {

    $elem = $elem || $(".data-grid-search-form[data-grid-session-id='" + dataGrid.id + "']");
    $elem.each(function() {
      var boundSearch = $(this).data("bound_search");
      if (typeof boundSearch !== "undefined" && boundSearch === true) {
        return true;
      }

      var dataGridId = $(this).attr("data-grid-session-id");
      $(this).submit(function(e) {
        if (dataGridHelper.getDataGrid(dataGridId).search()) {
          e.preventDefault();
        }

      });
      $(this).on("reset", function(e) {
        if (dataGridHelper.getDataGrid(dataGridId).reset().search()) {
          e.preventDefault();
        }

      });
      $(this).data("bound_search", true);
    });
  },
  bindPopState          : function() {
    if (this.boundPopState) {
      return true;
    }
    this.boundPopState = true;

    $(window).bind('popstate', function(e) {
      var state = e.originalEvent.state;
      if (typeof state !== "object" || state === null || state.dataGrid !== "yes") {
        state = {mode: "search"};
      }
      var preventRedirect = false;
      allDataGrids.forEach(function(dataGrid) {
        if (dataGrid.rowOpen) {
          preventRedirect = true;
          dataGrid.closeRow();
        }
      });
      if (preventRedirect) {
        return true;
      }
      if (state.mode === "openRow") {
        return true;
      }
      // noinspection SillyAssignmentJS
      window.location.href = window.location.href;
    });
  },
  bindRows              : function(dataGrid, $wrapper) {
    var $tbody = $wrapper.find("tbody");
    if (!$tbody.length && $wrapper.is("tbody")) {
      $tbody = $wrapper;
    }
    $tbody.click(function(e) {
      var $target = $(e.target);
      if ($target.hasClass("data-grid-no-row-open") || $target.closest(".data-grid-no-row-open").length) {
        return true;
      }
      dataGrid.openRow($(this));

    });

    var $closeButton = dataGrid.$open.find(".data-grid-details-close-button");
    if ($closeButton.data("bound") !== "yes") {
      $closeButton.click(function() {
        dataGrid.closeRow();
      });
      $closeButton.data("bound", "yes");
    }

    if (dataGrid.$open.data("bound-escape") !== "yes") {
      $("body").keyup(function(e) {
        if (e.key === "Escape") {
          if (dataGrid.rowOpen) {
            dataGrid.closeRow();
          }
        }
      });
      dataGrid.$open.data("bound-escape", "yes");
    }

  },
  bindGears             : function($elem) {
    if (typeof gearJS !== "undefined") {
      gearJS.auto($elem);
    }
  },
  bindAdditional        : function(dataGrid, $wrapper) {
    dataGrid.additionalBindingFunctions.forEach(function(additionalBindingFunction) {
      dataGridHelper.bindAdditionalSingle(dataGrid, additionalBindingFunction, $wrapper);
    });
  },
  bindAdditionalSingle  : function(dataGrid, settings, $wrapper) {
    $wrapper.find(settings.element).on(settings.trigger, function() {
      settings.callback(dataGrid);
    });
  },
  getDataGridFromElement: function($elem) {
    if (!($elem instanceof jQuery)) {
      $elem = $($elem);
    }
    var dataGridId;
    if ($elem.attr("data-grid-session-id")) {
      dataGridId = $elem.attr("data-grid-session-id");
    }
    else {
      var $wrapper = $elem.closest(".data-grid-wrapper");
      if (!$wrapper.length) {
        $wrapper = $elem.closest(".data-grid-search-form")
      }
      if (!$wrapper.length) {
        return false;
      }

      dataGridId = $wrapper.attr("data-grid-session-id");
    }
    var output = false;
    allDataGrids.forEach(function(dataGrid) {
      if (dataGrid.id === dataGridId) {
        output = dataGrid;
        return false;
      }
    });
    return output;
  },
  getRowFromElement     : function($elem) {
    if (!($elem instanceof jQuery)) {
      $elem = $($elem);
    }
    var $open = $elem.closest(".data-grid-open")
    if ($open.length) {
      return $open.data("row");
    }
    return $elem.closest(".data-grid-tbody");
  },
  searchButtonClick     : function(e) {

    var field        = $(this).attr("data-grid-field");
    var searchValue  = $(this).attr("data-grid-search-value");
    var thisDataGrid = $(".data-grid-wrapper[data-grid-session-id='" + $(this).attr("data-grid-session-id") + "']").dataGrid();

    if ($(this).hasClass("active")) {
      thisDataGrid.resetInput($(".data-grid-input[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']"));
      return true;
    }

    var checkIt = true;
    if (searchValue === "uncheck") {
      checkIt = false;
    }

    $(".data-grid-input:not([type=submit],[type=radio],[type=checkbox])[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']")
      .val(searchValue).change();
    $(".data-grid-input:not([type=submit],[type=input],[type=select])[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']" +
      "[value=" + JSON.stringify(searchValue) + "]")
      .prop("checked", checkIt);
    if (searchValue.length < 1) {
      $(".data-grid-input:not([type=submit],[type=input],[type=select])[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']" +
        "[data-grid-radio-blank='yes']")
        .prop("checked", true);
    }
    if (thisDataGrid.search()) {
      e.preventDefault();
    }

  },
  sortButtonClick       : function(e) {
    if (!dataGridHelper.allowSorting) {
      return true;
    }
    if ($(e.target).closest(".data-grid-top-corner").length) {
      return true;
    }
    if ($(e.target).closest(".data-grid-resize-column").length) {
      return true;
    }
    var $input         = $(this).find(".data-grid-input-sort");
    var $thisSortOrder = $(this).find(".data-grid-input-sort-order");
    var thisDataGrid   = $(".data-grid-wrapper[data-grid-session-id='" + $input.attr("data-grid-session-id") + "']").dataGrid();
    var $sortOrders    = $(".data-grid-input-sort-order[data-grid-session-id='" + thisDataGrid.id + "']");
    var $sorts         = $(".data-grid-input-sort[data-grid-session-id='" + thisDataGrid.id + "']");

    $thisSortOrder.val(null).change();
    if (e.shiftKey) {
      var largestCount = 0;
      $sorts.each(function() {
        if ($(this).val().length < 1) {
          return true;
        }
        var $thisSortOrder = $(this).closest("a").find(".data-grid-input-sort-order");
        if ($thisSortOrder.val().length < 1) {
          $thisSortOrder.val(0).change();
        }
        if (parseInt($thisSortOrder.val()) > largestCount) {
          largestCount = parseInt($thisSortOrder.val());
        }
      });
      $thisSortOrder.val(largestCount + 1).change();
    }
    else {
      $sortOrders.val(null).change();
      $sorts.val(null).change();
    }

    $input.val($input.attr("data-next-value")).change();

    if (thisDataGrid.search()) {
      e.preventDefault();
    }

  },

  sortButtonWrapperClick: function(e) {
    if (!dataGridHelper.allowSorting) {
      return true;
    }
    if ($(e.target).is("a")) {
      return true;
    }
    if ($(e.target).closest(".data-grid-top-corner").length) {
      return true;
    }
    if ($(e.target).closest(".data-grid-resize-column").length) {
      return true;
    }
    if (e.shiftKey) {
      var shiftClick      = jQuery.Event("click");
      shiftClick.shiftKey = true;
      $(this).find("a").trigger(shiftClick);
    }
    else {
      $(this).find("a").click();
    }
  },
};

$(".data-grid-wrapper").each(function() {
  var thisDataGrid = new DataGrid($(this));
  thisDataGrid.gatherVars();

  if (thisDataGrid.openFirstRow) {
    thisDataGrid.openRow(thisDataGrid.getRowNumElem(1));
  }
});

dataGridHelper.bindPopState();


function getDataGrid(name, searchType)
{
  searchType = searchType || "name";
  var output = false;
  allDataGrids.forEach(function(dataGrid) {
    if (searchType === "id" && parseInt(dataGrid[searchType]) === parseInt(name)) {
      output = dataGrid;
      return false;
    }
    if (dataGrid[searchType] === name) {
      output = dataGrid;
      return false;
    }
  });
  return output;
}

function getDataGrids(name)
{
  var output = [];
  allDataGrids.forEach(function(dataGrid) {
    if (dataGrid.name === name) {
      output.push(dataGrid);
    }
  });
  return output;
}

/* jquery extensions */

$.fn.dataGrid = function(mode, param) {
  var $open = this.closest(".data-grid-open");
  var $row;
  if ($open.length) {
    $row = $open.data("row");
    if (!($row instanceof jQuery)) {
      $row = null;
    }
  }
  else {
    $row = this.closest(".data-grid-tbody");
  }
  switch (mode) {
    case "value":
      if (!$row.length) {
        return false;
      }
      return dataGridHelper.getRowDataValue($row, param);
    case "row":
      if (!$row.length) {
        return false;
      }
      return dataGridHelper.getRowData($row);
    case "open":
      if (!$row.length) {
        return false;
      }
      dataGridHelper.getDataGridFromElement($row).openRow($row, param);

      break;
    case "close":
      if ($open.length) {
        dataGrid = dataGridHelper.getDataGrid($open.attr("data-grid-session-id")).closeRow();
      }
      else {
        dataGrid = dataGridHelper.getDataGridFromElement(this).closeRow();
      }

      break;
    default:
      var dataGrid;
      if ($open.length) {
        dataGrid = dataGridHelper.getDataGrid($open.attr("data-grid-session-id"));
      }
      else {
        dataGrid = dataGridHelper.getDataGridFromElement(this);
      }


      if (dataGrid === false) {
        return false;
      }
      dataGrid.$selectedRow = $row;
      return dataGrid;

  }


};

dataGridHelper.bindPopState();

$.fn.dataGridOpen = function(mode) {
  var $row = this.closest(".data-grid-tbody");
  if (!$row.length) {
    return false;
  }
  dataGridHelper.getDataGridFromElement($row).openRow($row, mode);
};

$.fn.dataGridRow   = function() {
  var $row = this.closest(".data-grid-tbody");
  if (!$row.length) {
    return false;
  }
  return dataGridHelper.getRowData($row);
};
$.fn.dataGridValue = function(value) {
  var $row = this.closest(".data-grid-tbody");
  if (!$row.length) {
    return false;
  }
  return dataGridHelper.getRowDataValue($row, value);
};

$("[data-grid-button-sort='yes']")
  .off("click", dataGridHelper.sortButtonWrapperClick)
  .click(dataGridHelper.sortButtonWrapperClick)
  .find("a")
  .off("click", dataGridHelper.sortButtonWrapperClick)
  .click(dataGridHelper.sortButtonClick);
$("[data-grid-button-search='yes']").off("click", dataGridHelper.searchButtonClick).click(dataGridHelper.searchButtonClick);

